// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/mrpService.ts
//  Planejamento de necessidades de materiais (MRP).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/planejamento-mrp';

export interface MrpDemanda {
  produtoId: number;
  quantidade: number;
}

export interface MrpNecessidade {
  materiaPrimaId: number;
  necessidadeBruta: number;
  saldoDisponivel: number;
  necessidadeLiquida: number;
}

export interface MrpResultado {
  necessidades: MrpNecessidade[];
  produtosSemFicha: number[];
}

export const mrpService = {
  async calcular(demandas: MrpDemanda[]): Promise<MrpResultado> {
    const { data } = await apiClient.post<MrpResultado>(`${BASE}/calcular`, { demandas });
    return data;
  },
};
